"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinnerSize = void 0;
var React = __importStar(require("react"));
var CustomLoadingWheel = function (props) {
    return (React.createElement("div", { className: "mt-5 text-center" },
        !props.spinnerSize && (React.createElement("div", { className: "spinner-border text-dark loading-spinner", role: "status" })),
        props.spinnerSize && props.spinnerSize === LoadingSpinnerSize.Large && (React.createElement("div", { className: "spinner-border text-dark loading-spinner", role: "status" })),
        props.spinnerSize && props.spinnerSize === LoadingSpinnerSize.Medium && (React.createElement("div", { className: "spinner-border text-dark loading-spinner-md", role: "status" }))));
};
exports.default = CustomLoadingWheel;
var LoadingSpinnerSize;
(function (LoadingSpinnerSize) {
    LoadingSpinnerSize["Large"] = "Large";
    LoadingSpinnerSize["Medium"] = "Medium";
})(LoadingSpinnerSize = exports.LoadingSpinnerSize || (exports.LoadingSpinnerSize = {}));
